import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 text-primary-950 font-heading font-bold text-lg">
                IABS
              </div>
              <div>
                <div className="font-heading font-bold text-background-50 text-lg">{t("footer.brand.name")}</div>
                <div className="text-xs text-background-100/70 tracking-widest">
                  {t("footer.brand.subtitle")}
                </div>
              </div>
            </div>
            <p className="text-sm text-background-100/80 leading-relaxed max-w-md">
              {t("footer.brand.desc")}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-background-50 font-heading font-bold text-base mb-5">{t("footer.quickLinks")}</h4>
            <ul className="space-y-3 text-sm">
              {[
                { key: "intro", label: t("footer.link.intro"), to: "/about/introduction" },
                { key: "org", label: t("footer.link.org"), to: "/about/organization" },
                { key: "research", label: t("footer.link.research"), to: "/research" },
                { key: "rankings", label: t("footer.link.rankings"), to: "/rankings/2025-top100" },
                { key: "news", label: t("footer.link.news"), to: "/news/articles" },
              ].map((l) => (
                <li key={l.key}>
                  <Link to={l.to} className="text-background-100/80 hover:text-accent-300 cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-background-50 font-heading font-bold text-base mb-5">{t("footer.contact")}</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-2-line w-5 h-5 flex items-center justify-center text-accent-400 mt-0.5"></i>
                <span className="text-background-100/80">{t("footer.address")}</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-accent-400 mt-0.5"></i>
                <span className="text-background-100/80">+852 2856 0333</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center text-accent-400 mt-0.5"></i>
                <span className="text-background-100/80">info@iabs.com.hk</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-100/70">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-6 text-xs text-background-100/70">
            <a href="#" className="hover:text-accent-300 cursor-pointer">{t("footer.privacy")}</a>
            <a href="#" className="hover:text-accent-300 cursor-pointer">{t("footer.terms")}</a>
            <a href="#" className="hover:text-accent-300 cursor-pointer">{t("footer.sitemap")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}